module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"slate__mvpd__not__supported\" class=\"slate\">\n    <div class=\"slate__wrapper\">\n        <div class=\"slate__description\">\n            <p>\n                This local station is not supported by your TV Provider, but we’re adding more local stations to TV\n                Providers all the time… Meanwhile, watch the latest episodes of your favorite CBS shows on demand the\n                day after they air as well as free live streaming channels!\n            </p>\n\n            <div class=\"slate__signup__box\">\n                <a href=\"/\" class=\"button primary\" role=\"button\" tabindex=\"0\" aria-label=\"Go to home\">\n                    <div class=\"button__text\" role=\"button\" tabindex=\"0\">Go to home</div>\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output;

}